export const locale = {
  back: 'Back',
  close: 'Close',
  last: 'Finish',
  next: 'Next',
  ski: 'Skip'
}

const buttonStyle = {
  margin: '20px',
  borderRadius: '5px',
  border: '1px solid var(--color-primary)',
  padding: '.9rem',
  marginTop: 0
}

export const styles = {
  options: {
    arrowColor: 'var(--color-primary)',
    backgroundColor: 'var(--surface-bg)',
    overlayColor: 'var(--tour-overlay-scrim)',
    primaryColor: 'var(--color-primary)',
    textColor: 'var(--text-heading)',
    width: '23rem',
    zIndex: 9998
  },
  buttonBack: {
    ...buttonStyle,
    marginLeft: 'auto',
    color: 'var(--brand-accent-color)'
  },
  buttonSkip: {
    ...buttonStyle,
    marginRight: 'auto',
    color: 'var(--brand-accent-color)'
  },
  buttonNext: {
    ...buttonStyle,
    marginLeft: 'auto'
  },
  buttonClose: {
    display: 'none'
  },
  spotlight: {
    backgroundColor: 'var(--tour-spotlight-color)',
    border: '2px solid var(--tour-spotlight-color)',
    height: '70px',
    top: '85px'
  }
}
